/* eslint-disable no-console */
// NPM Imports
import uuid from "react-native-uuid";
import { batch } from "react-redux";

// Store Import
import store from "../../store";

// Service Imports
import {
  fetchDocumentTemplates,
  createTemplate,
  fetchQuotetermTemplateByID,
  saveClauseInformation,
  switchTemplateSections,
  deleteTemplateById,
  fetchDocTemplateById,
  fetchDynamicFields,
  fetchDocCustomField,
  updateTemplateComponentService,
  // workflow related services
  createTempWorkFlowService,
  getTempWorkFlowDetailsService,
  removeRuleFromTemplateWFService,
  removeWorkFlowFromTemplateService,
  updateTemplateWFConditionService,
  cloneTemplateService,
  changeTemplateStatusService,
  updatetemplateTagService,
  getTemplateSearchSuggestions,
  getTemplateSearchContent,
  getGlobalTemplates,
  updateTemplateDetailsService,
  deleteStripeFromTemplate,
  batchUpdateComponentTemplateService,
  assignUserGroupToTemplateService,
  searchDocumentTemplates,
  assignRecipientTypeService,
  downloadTemplateCsvService,
  downloadTemplateJsonDataService,
  addLogicToFieldsInTemplateService,
  removeLogicForFieldService,
} from "./templateService";

import { updateToolPaneData } from "../QuotationActions/QuotationActions";

// import { fetchAllDocumentTypes } from "../DocumentActions/services";
import { fetchAllUsers } from "../PipelineActions/pipelineServices";
import { fetchUserGroupsService } from "../UserActions/userService";
import {
  getAssetStatusListService,
  getAssetTagsListService,
} from "../AssetActions/assetServices";

// Method Impports
import {
  generateTempFormFiled,
  generateTempWrkFlowMetaData,
  parseTempWrkFlowData,
  sortTemplatesList,
  splitTemplateSearchContent,
  getFormFieldSectionMapping,
  filterOutTemplatesByStatus,
} from "./templateMethod";

import { prepareStatusMap } from "../KanbanActions/kanbanMethods";

// Internal Imports
import {
  convertIntermediateJson,
  getLayoutAndComponents,
  updateComponentDataForTemplates,
  checkIfAnyTableIsLinkedToDataSource,
  convertSignersData,
} from "../../utils/documentUtils";
import { convertDocumentContentV2 } from "../../utils/quotationUtils";
import { DOCUMENTS, TEMPLATE, TOOLPANE } from "../../constants";

// Destructuring
const { DOCUMENT_MODE } = DOCUMENTS;
const { TEMP_FORM_FIELD_DATA } = TEMPLATE;
const { TOOLPANE_TTITLE } = TOOLPANE;

export const getTemplateInitData =
  (pageNum = 1, update = false) =>
  async dispatch => {
    try {
      const templates = await fetchDocTemplateById(null, pageNum, true);
      Promise.all([templates])
        .then(response => {
          const {
            data: { Templates } = {},
            headers: { has_more: hasMore } = {},
          } = response[0];
          const sortedTempLists = sortTemplatesList(Templates);
          let dispatchType = "FETCH_DOCUMENT_TEMPLATES";
          if (update) {
            dispatchType = "LOAD_MORE_DOCUMENT_TEMPLATES";
          }
          dispatch({
            type: dispatchType,
            payload: {
              templates: sortedTempLists,
              hasMore: hasMore === "true",
              pageNum,
            },
          });
        })
        .catch(error => {
          throw error;
        });
      return templates;
    } catch (error) {
      throw error;
    }
  };

export const fetchAllDocumentTemplates =
  (pageNum = 1, update = false, filters) =>
  dispatch =>
    new Promise((resolve, reject) => {
      // page number and response with headers
      fetchDocumentTemplates(pageNum, true, filters)
        .then(response => {
          const {
            data: { Templates: templates, isGlobalOrg } = {},
            headers: { has_more: hasMore } = {},
          } = response;
          let dispatchType = "FETCH_DOCUMENT_TEMPLATES";
          if (update) {
            dispatchType = "LOAD_MORE_DOCUMENT_TEMPLATES";
          }
          dispatch({
            type: dispatchType,
            payload: {
              templates,
              hasMore: hasMore === "true",
              pageNum,
              isGlobalOrg,
            },
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });

export const fetchDocumentTemplatesById =
  (typeId, pageNum = 1, update = false) =>
  dispatch =>
    new Promise((resolve, reject) => {
      fetchDocTemplateById(typeId, pageNum, true)
        .then(response => {
          const {
            data: { Templates: templates } = {},
            headers: { Has_more: hasMore } = {},
          } = response;
          let dispatchType = "FETCH_DOCUMENT_TEMPLATES";
          if (update) {
            dispatchType = "LOAD_MORE_DOCUMENT_TEMPLATES";
          }
          dispatch({
            type: dispatchType,
            payload: {
              templates,
              hasMore: hasMore === "true",
              pageNum,
            },
          });
          resolve("success");
        })
        .catch(error => {
          reject(error);
        });
    });

export const createNewTemplate = (templateDetails, docDetails) =>
  createTemplate(templateDetails, docDetails)
    .then(response => {
      console.debug(response.URI);
      return response;
    })
    .catch(error => error);

export const getTemplateByID = templateID => dispatch => {
  try {
    const templates = fetchQuotetermTemplateByID(templateID);
    const dynamicFields = fetchDynamicFields();
    return Promise.all([templates, dynamicFields])
      .then(response => {
        // Only required to convert when creating template from document
        if (
          response[0].components_update_required ||
          checkIfAnyTableIsLinkedToDataSource(response[0].components_v2)
        ) {
          const updatedComponents = updateComponentDataForTemplates(
            response[0].components_v2,
          );
          if (updatedComponents.length > 0) {
            batchUpdateComponentTemplateService(response[0].id, {
              components: [...updatedComponents],
            });
          }
        }

        const { layout, components } = getLayoutAndComponents(
          response[0].components_v2 || [[]],
        );

        const fieldSectionMapping = getFormFieldSectionMapping(components);
        let componentMapping = convertDocumentContentV2(
          components,
          DOCUMENT_MODE.TEMPLATE,
        );

        let signatories = [];
        if (
          response[0].is_pdf_document &&
          response[0].signatories &&
          response[0].signatories.length > 0
        ) {
          let SignerListData = {};
          response[0].signatories.forEach((item, index) => {
            const data = {
              header: "",
              id: item.component_id,
              label: `Signature ${index + 1}`,
              lock: false,
              type: "Signature",
              data: item.signers,
            };
            SignerListData = {
              ...SignerListData,
              [item.component_id]: { content: { ...data } },
            };

            signatories.push({
              ...item,
              signers: convertSignersData(item.signers),
            });
          });
          componentMapping = {
            ...SignerListData,
          };
        } else {
          signatories = response[0].signatories;
        }

        const documentData = {
          layout,
          components: componentMapping,
          image_base_url: response[0].image_base_url,
        };
        const template = {
          ...response[0],
        };

        const isPdfDocument = response[0].is_pdf_document
          ? response[0].is_pdf_document
          : false;
        const isFillablePDF = response[0].pdf_form_fields
          ? true
          : response[0].is_fillable_pdf;
        const pdfFormFields = response[0].pdf_form_fields
          ? response[0].pdf_form_fields.pdf_form_fields
          : null;
        const isDynamicPDF = response[0].is_dynamic_pdf
          ? response[0].is_dynamic_pdf
          : false;
        const pdfUrl = `${response[0].image_base_url}${response[0].pdf_url}`;

        dispatch({
          type: "FETCH_TEMPLATE_DETAILS",
          payload: {
            template,
            fields: response[1],
            documentData,
            fieldSectionMapping,
            isPdfDocument,
            isFillablePDF,
            pdfFormFields,
            isDynamicPDF,
            pdfUrl,
            signatories,
            signatoriesV2: response[0].signatories_v2,
          },
        });
        if (isPdfDocument) {
          dispatch({
            type: "UPDATE_TOOLPANE_DATA",
            payload: {
              view: TOOLPANE_TTITLE.SIGNATURE_COMPONENTS,
              page: "PDF_TEMPLATE",
              isOpen: true,
            },
          });
        }

        return {
          template,
          fields: response[1],
        };
      })
      .catch(error => {
        throw error;
      });
  } catch (error) {
    console.error(`documentTemplateActions => getTemplateByID => ${error}`);
    throw error;
  }
};

export const nukeTemplateDetails = () => dispatch => {
  dispatch({
    type: "NUKE_TEMPLATE",
  });
  dispatch({
    type: "RESET_UNDO_REDO_STACK",
  });
};

export const updateTemplateTitle = updatedTitle => dispatch => {
  dispatch({
    type: "UPDATE_TEMPLATE_TITLE",
    payload: updatedTitle,
  });
};
export const updateTemplateMetaAction = payload => dispatch => {
  dispatch({
    type: "UPDATE_TEMPLATE_META",
    payload,
  });
};

export const updateTemplateMeta = payload => dispatch =>
  new Promise((resolve, reject) => {
    updateTemplateDetailsService(payload)
      .then(response => {
        dispatch({
          type: "UPDATE_TEMPLATE_META",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        console.debug("documentTemplateActions => updateTemplateMeta", error);
        reject(error);
      });
  });

export const toggleTemplateStatus =
  (templateID, pageNum = 1, update = false) =>
  dispatch =>
    switchTemplateSections(templateID)
      .then(response => {
        fetchDocumentTemplates(pageNum, true)
          .then(res => {
            const {
              data: { Templates: templates } = {},
              headers: { Has_more: hasMore } = {},
            } = res;
            let dispatchType = "FETCH_DOCUMENT_TEMPLATES";
            if (update) {
              dispatchType = "LOAD_MORE_DOCUMENT_TEMPLATES";
            }
            dispatch({
              type: dispatchType,
              payload: {
                templates,
                pageNum,
                hasMore: hasMore === "true",
              },
            });
          })
          .catch(error => error);
        return response;
      })
      .catch(error => error);

export const deleteTemplate = templateID => dispatch =>
  new Promise((resolve, reject) => {
    deleteTemplateById(templateID)
      .then(response => {
        const reduxState = store.getState();
        const { documentTemplates } = reduxState.TemplateStore;
        const cloneTemplates = [...documentTemplates];
        const updateTemplates = cloneTemplates.filter(
          template => template.id !== templateID,
        );
        dispatch({
          type: "DELETE_TEMPLATE",
          payload: updateTemplates,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const saveClause = (clauseName, clauseId, clauseContent) =>
  saveClauseInformation(clauseName, clauseId, clauseContent)
    .then(response => response)
    .catch(error => error);

export const updateHoveredTemplateSectionId =
  (sectionID, updateAfterSection) => dispatch => {
    dispatch({
      type: "UPDATE_HOVERED_TEMPLATE_SECTION_ID",
      payload: { sectionID, updateAfterSection },
    });
  };

export const updateSectionInTemplate =
  (section, addedNewTextSection) => dispatch => {
    dispatch({
      type: "UPDATE_SECTION_IN_TEMPLATE",
      payload: { section, addedNewTextSection },
    });

    // ---- For DocumentReducer only -----
    if (addedNewTextSection && addedNewTextSection.type !== "EmptyContainer") {
      let tempClickedActiveComponentId = addedNewTextSection.id;
      if (addedNewTextSection.type === "Table") {
        const { data: secData } = addedNewTextSection;
        if (secData && secData.data && secData.data.length > 0) {
          const [firstRow] = secData.data;
          if (firstRow && firstRow.data && firstRow.data.length > 0) {
            const [firstCellOfFirstRow] = firstRow.data;
            const {
              attributes: { id },
            } = firstCellOfFirstRow;
            if (id) {
              tempClickedActiveComponentId = id;
            }
          }
        }
      }
      dispatch({
        type: "UPDATE_DOCUMENT_CLICKED_COMPONENT_ID",
        payload: {
          clickedActiveComponentId: tempClickedActiveComponentId,
          preventClickedComponentIdUpdate: true,
          clickedActiveComponentType: addedNewTextSection.type,
        },
      });
    }
  };

export const addClause = clause => dispatch => {
  dispatch({
    type: "ADD_TEMPLATE_CLAUSES",
    payload: clause,
  });
};

export const removeClause = clause => dispatch => {
  dispatch({
    type: "REMOVE_TEMPLATE_CLAUSES",
    payload: clause,
  });
};

export const reOrderTemplateSectionList = sectionList => dispatch => {
  dispatch({
    type: "REORDER_TEMPLATE_SECTIONLIST",
    payload: {
      sectionList,
    },
  });
};

export const saveDynamicField =
  (componentDetails, activeComponentDetails, editorStateDetails) => dispatch =>
    new Promise((resolve, reject) => {
      updateTemplateComponentService(componentDetails)
        .then(response => {
          const { fieldDiffList: { added = [], deleted = [] } = {} } =
            componentDetails;
          let newMapping = null;
          if (
            (Array.isArray(added) && added.length > 0) ||
            (Array.isArray(deleted) && deleted.length > 0)
          ) {
            const { TemplateStore } = store.getState();
            const { fieldSectionMapping } = TemplateStore;
            const sectionID =
              componentDetails.section_id || componentDetails.id;
            newMapping = {
              ...fieldSectionMapping,
            };
            added.forEach(fieldID => {
              if (
                fieldID in fieldSectionMapping &&
                Array.isArray(fieldSectionMapping[fieldID])
              ) {
                const idList = fieldSectionMapping[fieldID];
                if (!idList.includes(sectionID)) {
                  idList.push(sectionID);
                }
                newMapping[fieldID] = idList;
              } else {
                newMapping[fieldID] = [sectionID];
              }
            });
            deleted.forEach(fieldID => {
              if (Array.isArray(fieldSectionMapping[fieldID])) {
                const idList = fieldSectionMapping[fieldID].filter(
                  id => id !== sectionID,
                );
                if (idList.length > 0) {
                  newMapping[fieldID] = idList;
                } else {
                  delete newMapping[fieldID];
                }
              }
            });
          }
          dispatch({
            type: "UPDATE_TEMPLATE_SECTION_WITH_DYNAMIC_FIELD",
            payload: {
              component: componentDetails,
              fieldSectionMapping: newMapping,
            },
          });
          if (activeComponentDetails && activeComponentDetails.id) {
            dispatch({
              type: "UPDATE_DOCUMENT_CLICKED_COMPONENT_ID",
              payload: {
                clickedActiveComponentId: activeComponentDetails.id,
                preventClickedComponentIdUpdate: activeComponentDetails.flag,
                clickedActiveComponentType: activeComponentDetails.type,
              },
            });
          }
          if (editorStateDetails && editorStateDetails.editorState) {
            dispatch({
              type: "INIT_ACTIVE_EDITOR",
              payload: {
                activeEditorState: editorStateDetails.editorState,
                activeComponent: editorStateDetails.section,
                activeComponentInfo: editorStateDetails.activeComponentMeta,
              },
            });
          }
          dispatch({
            type: "CHANGE_DYNAMIC_FIELD_VIEW",
            payload: "LIST",
          });
          dispatch({
            type: "UPDATE_TOOLPANE_DATA",
            payload: {
              isOpen: true,
              view: "dynamic-fields",
            },
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });

export const getCustomFieldType = () => dispatch => {
  fetchDocCustomField()
    .then(res => {
      res = convertIntermediateJson(res);
      dispatch({
        type: "FETCH_CUSTOM_FIELD",
        payload: res,
      });
      dispatch({
        type: "CHANGE_DYNAMIC_FIELD_VIEW",
        payload: "CUSTOM",
      });
    })
    .catch(error => error);
};

export const selectedDynamicFieldDataForUpdate = data => dispatch =>
  dispatch({
    type: "SELECTED_DYNAMIC_FIELD_DATA_FOR_UPDATE",
    payload: data,
  });

export const selectedDynamicFieldToAddLogic = data => dispatch =>
  dispatch({
    type: "SELECTED_DYNAMIC_FIELD_TO_ADD_LOGIC",
    payload: data,
  });

export const toggleDynamicFieldView = view => dispatch =>
  dispatch({
    type: "CHANGE_DYNAMIC_FIELD_VIEW",
    payload: view,
  });

export const addDynamicFieldinList = field => dispatch => {
  dispatch({
    type: "ADD_DYNAMIC_FIELD_IN_LIST",
    payload: field,
  });
  dispatch({
    type: "UPDATE_TOOLPANE_DATA",
    payload: { view: "dynamic-fields", isOpen: true },
  });
};

export const updateDynamicFieldinList = field => dispatch => {
  dispatch({
    type: "UPDATE_DYNAMIC_FIELD_IN_LIST",
    payload: field,
  });
};

export const addClauseOptions = componentId => dispatch => {
  const reduxState = store.getState();
  // const { components } = reduxState.DocumentStore;
  // const sectionData = components[componentId];
  const {
    EditorStore: { activeComponent, activeEditorState },
  } = reduxState;
  if (componentId === activeComponent.id) {
    dispatch({
      type: "ADD_CLAUSE_OPTIONS",
      payload: {
        component: {
          ...activeComponent,
          data: activeEditorState
            ? activeEditorState.getCurrentContent()
            : activeComponent.data,
        },
      },
    });
  }
};

export const convertToImageField =
  ({ section, blockType, blockID }) =>
  dispatch => {
    dispatch({
      type: "CONVERT_TO_IMAGE_FIELD",
      payload: {
        section,
        blockType,
        blockID,
      },
    });
  };

export const editClauseOption = (section, clauseOptionsDetails) => dispatch => {
  dispatch({
    type: "EDIT_CLAUSE_OPTIONS",
    payload: { section, clauseOptions: clauseOptionsDetails },
  });
};

export const updateClauseOption = activeClauseValue => dispatch => {
  dispatch({
    type: "UPDATE_CLAUSE_OPTIONS",
    payload: activeClauseValue,
  });
};

export const updateActiveClauseView = clauseId => dispatch => {
  dispatch({
    type: "UPDATE_ACTIVE_CLAUSE_VIEW",
    payload: clauseId,
  });
};

export const editImageFormField =
  (section, clauseOptions, blockID, blockType) => dispatch => {
    dispatch({
      type: "EDIT_IMAGE_FORM_FIELD",
      payload: { section, clauseOptions, blockID, blockType },
    });
  };

export const nukeClauseOptions = () => dispatch => {
  dispatch({
    type: "NUKE_CLAUSE_OPTIONS",
  });
};

export const nukeImageFormField = () => dispatch => {
  dispatch({
    type: "NUKE_IMAGE_FORM_FIELD",
  });
};

export const updateClauseOptionsAndSection = (clause, section) => dispatch => {
  const payload = {
    section,
    clauseOption: clause,
  };
  dispatch({
    type: "UPDATE_CLAUSE_OPTIONS_AND_SECTION",
    payload,
  });
};

export const updateImageFormFieldAndSection =
  (imageFormField, section) => dispatch => {
    const payload = {
      section,
      imageFormField,
    };
    dispatch({
      type: "UPDATE_IMAGE_FORM_FIELD_AND_SECTION",
      payload,
    });
  };

export const updateTemplateSection = section => dispatch => {
  updateTemplateComponentService(section).then(() => {
    dispatch({
      type: "UPDATE_SECTION_IN_TEMPLATE",
      payload: { section },
    });
  });
};

// ---------- Template Workflow Related Actions ----------
export const createTempWorkFlow = payload => dispatch =>
  new Promise((resolve, reject) => {
    createTempWorkFlowService(payload)
      .then(response => {
        dispatch({
          type: "UPDATE_TEMPLATE_ENTITY",
          payload: response.id,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getInitData = id => async dispatch => {
  try {
    const workFlowDetails = await getTempWorkFlowDetailsService(id);
    const users = await fetchAllUsers();
    const userGroups = await fetchUserGroupsService();

    Promise.all([workFlowDetails, users, userGroups])
      .then(response => {
        const metaData = generateTempWrkFlowMetaData(response[1], response[2]);
        const workflowData = parseTempWrkFlowData(response[0], metaData);
        const formFields = generateTempFormFiled(response[0], metaData);
        const payload = {
          formFields,
          metaData,
          userGroups: response[2].Usergroups,
          users: response[1].users,
          workflowData,
        };
        dispatch({
          type: "REACTION_TEMP_WORKFLOW_INIT_DATA",
          payload,
        });
      })
      .catch(error => {
        console.debug(`templateActions => getInitData" => ${error}`);
        throw error;
      });
    return null;
  } catch (error) {
    throw error;
  }
};

export const toggleWorkFlowScreen = data => dispatch => {
  const {
    entity: { wfId },
  } = data;
  dispatch({
    type: "TOGGLE_TEMP_WORKFLOW_SCREEN",
    payload: data,
  });
  if (!wfId) {
    dispatch({
      type: "NUKE_TEMP_WORKFLOW_FORMFIELDS",
    });
  }
};

export const addNewRuleToTemplateWF = formFields => dispatch => {
  const formFiledsClone = formFields.map(data => data);
  const defaultPayload = generateTempFormFiled();

  //* Make the item dirty, so only the changed values are added to API call
  defaultPayload[0].isDirty = true;

  const updatedFormFileds = [...formFiledsClone, ...defaultPayload];
  dispatch({
    type: "UPDATE_TEMP_WORKFLOW_FORMFIELDS",
    payload: updatedFormFileds,
  });
};

export const removeRuleFromTemplateWF =
  (formFields, data, ruleIndex) => dispatch =>
    new Promise((resolve, reject) => {
      // * Method to remove the deleted rule from arrayOfObj & update in redux
      function updateWorkFlowRuleList() {
        const formFiledsClone = formFields.filter((rule, index) => {
          if (index !== ruleIndex) {
            return rule;
          }
          return false;
        });
        dispatch({
          type: "UPDATE_TEMP_WORKFLOW_FORMFIELDS",
          payload: formFiledsClone,
        });
      }

      // * If the rule is not save in backend, then remove locally in redux
      if (typeof data.id === "string") {
        updateWorkFlowRuleList();
      }
      // * If the rule is saved in backend, then make API call to remove & then in redux
      else {
        removeRuleFromTemplateWFService(data.id)
          .then(response => {
            updateWorkFlowRuleList();
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      }
    });

export const updateTempWorkFlowData = (key, value, index) => dispatch => {
  const reduxState = store.getState();
  const {
    workflow: { formFields },
  } = reduxState.TemplateStore;
  const updatedFormFields = [...formFields];

  //* Make the item dirty, so only the changed values are added to API call
  updatedFormFields[index].isDirty = true;

  updatedFormFields[index][key] =
    typeof value === "string"
      ? value
      : { ...updatedFormFields[index][key], ...value };
  dispatch({
    type: "UPDATE_TEMP_WORKFLOW_FORMFIELDS",
    payload: updatedFormFields,
  });
};

export const updateTemplateWFCondition =
  (id, payload, metaData, scopeType) => dispatch =>
    new Promise((resolve, reject) => {
      //* Filter out the dirty rule(s) for the API
      const dirtyFormFields = payload.filter(rule => rule.isDirty);
      if (dirtyFormFields.length > 0) {
        updateTemplateWFConditionService(id, dirtyFormFields)
          .then(response => {
            //* Replace the updated rule from API into redux
            let index = 0;
            const updatedResponse = payload.map(rule => {
              if (rule.isDirty) {
                rule = response[index];
                index += 1;
              }
              delete rule.isDirty;
              return rule;
            });

            //* Parse the API JSON to FrontEnd Structure
            const workflowData = parseTempWrkFlowData(
              updatedResponse,
              metaData,
            );
            const formFields = generateTempFormFiled(
              workflowData,
              metaData,
              scopeType,
            );

            dispatch({
              type: "UPDATE_TEMP_WORKFLOW_RULE",
              payload: {
                workflowData,
                formFields,
              },
            });
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      } else {
        resolve(true);
      }
    });

export const nukeTempRuleSet = index => dispatch => {
  const {
    workflow: { formFields },
  } = store.getState().TemplateStore;
  const cloneFields = formFields.map(field => field);
  const newRule = Object.assign({}, TEMP_FORM_FIELD_DATA, {
    id: uuid.v4(),
  });
  cloneFields[index] = newRule;
  dispatch({
    type: "UPDATE_TEMP_WORKFLOW_FORMFIELDS",
    payload: cloneFields,
  });
};

export const updateUsedFields = fields => dispatch =>
  dispatch({
    type: "UPDATE_TEMP_USEDFIELDS",
    payload: fields,
  });

export const removeWorkFlowFromTemplate =
  (workflowId, WFAttachedFields) => () =>
    new Promise((resolve, reject) => {
      removeWorkFlowFromTemplateService(workflowId)
        .then(response => {
          const updatedWFAttachedFileds = WFAttachedFields.map(fields => {
            if (fields.wf_id === workflowId) {
              delete fields.wf_id;
            }
            return fields;
          });
          store.dispatch(updateUsedFields(updatedWFAttachedFileds));
          store.dispatch(toggleWorkFlowScreen({ flag: false, entity: {} }));
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });

export const setCommonFieldValues = commonFieldValues => dispatch =>
  dispatch({
    type: "SET_COMMON_FIELDS",
    payload: commonFieldValues,
  });

export const setFlagForCommonFields = status => dispatch =>
  dispatch({
    type: "SET_FLAG_FOR_COMMON_FIELDS",
    payload: status,
  });

export const setFlagForDefault = status => dispatch =>
  dispatch({
    type: "SET_FLAG_FOR_DEFAULT",
    payload: status,
  });

export const metaValidStatus = status => dispatch =>
  dispatch({
    type: "META_VALID_STATUS",
    payload: status,
  });

export const setMetaFieldValues = metaFieldValues => dispatch =>
  dispatch({
    type: "SET_META_FIELDS",
    payload: metaFieldValues,
  });

export const nukeDynamicFileData = () => dispatch =>
  dispatch({
    type: "NUKE_DYNAMIC_FIELD_DATA",
  });

export const cloneTemplate = (id, title) => () =>
  new Promise((resolve, reject) => {
    cloneTemplateService(id, title)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const publishTemplate = (id, payload) => dispatch =>
  new Promise((resolve, reject) => {
    changeTemplateStatusService(id, payload)
      .then(response => {
        dispatch({
          type: "PUBLISH_TEMPLATE",
          payload: payload.template_type,
        });
        dispatch({
          type: "RECALCULATE_PAGE_BREAKS",
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const changeTemplateStatus = (id, payload, isTempList) => dispatch =>
  new Promise((resolve, reject) => {
    changeTemplateStatusService(id, payload)
      .then(response => {
        // Update the status of current template in templates list
        if (isTempList) {
          const reduxState = store.getState();
          const { documentTemplates, templatesStatusFilters } =
            reduxState.TemplateStore;
          const updateTemplates = documentTemplates.map(template => {
            if (template.id === id) {
              return {
                ...template,
                status: payload.status,
              };
            }
            return template;
          });
          // const payload =
          let newTemplateList = updateTemplates;
          if (templatesStatusFilters.length > 0) {
            newTemplateList = filterOutTemplatesByStatus(
              updateTemplates,
              templatesStatusFilters,
            );
          }
          dispatch({
            type: "TEMPLATES_LIST_STATUS_CHANGE",
            payload: newTemplateList,
          });
          dispatch({
            type: "RECALCULATE_PAGE_BREAKS",
          });
        }
        // Update the status of current template
        else {
          // changing tabView to "TEMPLATE" as we donot show tabs
          dispatch({
            type: "TOGGLE_TEMPLATE_TAB_VIEW",
            payload: {
              tabView: "TEMPLATE",
            },
          });
          dispatch({
            type: "TEMPLATE_STATUS_CHANGE",
            payload: payload.status,
          });
          dispatch({
            type: "RECALCULATE_PAGE_BREAKS",
          });
        }
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const addDynamicFieldinListAsync = (field, callback) => dispatch => {
  dispatch(addDynamicFieldinList(field));

  // update component api call
  return callback();
};

export const updateTemplateTagAction = (templateId, newTag) => dispatch =>
  new Promise((resolve, reject) => {
    updatetemplateTagService(templateId, newTag.id)
      .then(res => {
        dispatch({
          type: "UPDATE_TEMPLATE_TAG",
          payload: { newTag, templateId },
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

// Template Page V2 actions
export const fetchStatusAndTagsList = () => async dispatch => {
  try {
    const status = await getAssetStatusListService(); // To fetch the Asset Status List
    const tags = await getAssetTagsListService(); // To fetch the Asset Tag/Type List

    Promise.all([status, tags])
      .then(response => {
        batch(() => {
          dispatch({
            type: "ASSET_STATUS_LIST",
            payload: { statusList: response[0] },
          });
          dispatch({
            type: "ASSET_TAGS_LIST",
            payload: {
              tagsList: response[1],
            },
          });
          // needed for kanban
          dispatch({
            type: "KANBAN_STATUS_MAP",
            payload: prepareStatusMap(response[0]),
          });
        });
      })
      .catch(error => {
        console.debug(`templateActions => getInitData" => ${error}`);
        throw error;
      });
    return null;
  } catch (error) {
    throw error;
  }
};

export const updateTemplateDocSectionLockUnlock = sectionData => dispatch => {
  const { type, headerFooterType, sectionID, parentSectionId, lockStatus } =
    sectionData;
  const reduxState = store.getState();
  const {
    template: {
      content: { sections },
    },
  } = reduxState.TemplateStore;
  let tempSections = null;
  let updatedSection = null;
  if (type === "NORMAL_SECTION") {
    tempSections = sections.map(sec => {
      if (sec.id === sectionID) {
        updatedSection = { ...sec, lock: lockStatus };
        return { ...sec, lock: lockStatus };
      }
      return { ...sec };
    });
  } else if (type === "COVERPAGE") {
    const filterCoverPageSection = sections.filter(
      sec => sec.id === parentSectionId,
    );
    if (filterCoverPageSection && filterCoverPageSection.length > 0) {
      const coverPageSection = filterCoverPageSection[0];
      const {
        data: { data },
      } = coverPageSection;
      const updatedData =
        Array.isArray(data) &&
        data.map(sec =>
          sec.id === sectionID ? { ...sec, lock: lockStatus } : { ...sec },
        );
      const tempUpdatedSection = {
        ...coverPageSection,
        data: {
          ...coverPageSection.data,
          data: updatedData,
        },
      };
      updatedSection = { ...tempUpdatedSection };
      tempSections = sections.map(sec =>
        sec.id === parentSectionId ? { ...tempUpdatedSection } : { ...sec },
      );
    }
  } else if (type === "HEADER_FOOTER") {
    const filterHeaderFooterSection = sections.filter(
      sec => sec.id === parentSectionId,
    );
    if (filterHeaderFooterSection && filterHeaderFooterSection.length > 0) {
      const headerFooterSection = filterHeaderFooterSection[0];
      const { data: hfData } = headerFooterSection;
      const { data } = hfData[headerFooterType];
      const updatedData =
        Array.isArray(data) &&
        data.map(sec =>
          sec.id === sectionID ? { ...sec, lock: lockStatus } : { ...sec },
        );
      const tempUpdatedSection = {
        ...headerFooterSection,
        data: {
          ...headerFooterSection.data,
          [headerFooterType]: {
            ...headerFooterSection.data,
            data: updatedData,
          },
        },
      };
      updatedSection = { ...tempUpdatedSection };
      tempSections = sections.map(sec =>
        sec.id === parentSectionId ? { ...tempUpdatedSection } : { ...sec },
      );
    }
  }

  dispatch({
    type: "UPDATE_TEMAPLATE_DOC_SECTION_LOCK_UNLOCK",
    payload: {
      sections: tempSections || [],
    },
  });

  updateTemplateComponentService(updatedSection)
    .then(() => {})
    .catch(error => {
      console.error(
        `TemplateActions => updateTemplateDocSectionLockUnlock => Error : ${error}`,
      );
    });
};

export const updateTemplateSearchSuggestions = (keyword, global) => dispatch =>
  new Promise((resolve, reject) => {
    getTemplateSearchSuggestions(keyword, global)
      .then(res => {
        if (res && res.Templates) {
          dispatch({
            type: "UPDATE_TEMPLATE_SEARCH_SUGGESTIONS",
            payload: {
              templateSearchSuggestions: res.Templates,
            },
          });
        }
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateTemplateSearchContent =
  (keyword, global, page = 0, filters) =>
  dispatch =>
    new Promise((resolve, reject) => {
      getTemplateSearchContent(keyword, global, page, filters)
        .then(res => {
          if (res && res.page) {
            const content = splitTemplateSearchContent(res.page);
            if (global) {
              dispatch({
                type: "UPDATE_GLOBAL_TEMPLATE_SEARCH_CONTENT",
                payload: {
                  templateSearchContent: content.templateSearchContent,
                  globalTemplates: content.templates,
                  searchTerm: keyword,
                },
              });
            } else {
              dispatch({
                type: "UPDATE_TEMPLATE_SEARCH_CONTENT",
                payload: {
                  templateSearchContent: content.templateSearchContent,
                  templates: content.templates,
                  searchTerm: keyword,
                },
              });
            }
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const clearTemplateSearchTerm = () => dispatch => {
  dispatch({
    type: "CLEAR_SEARCH_TERM",
  });
};

export const updateGlobalTemplates = () => dispatch =>
  new Promise((resolve, reject) => {
    getGlobalTemplates()
      .then(res => {
        dispatch({
          type: "UPDATE_GLOBAL_TEMPLATES",
          payload: {
            globalTemplates: res,
          },
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const coverpageThemeAction = view => dispatch => {
  const reduxState = store.getState();
  const { coverpageThemeActionLabel } = reduxState.TemplateStore;
  if (!(coverpageThemeActionLabel === null && view === null)) {
    dispatch({ type: "COVERPAGE_THEME_ACTION", payload: view });
  }
};

export const removeDisabledStripeButtonfromTemplate =
  (stripeData, TempID) => dispatch =>
    new Promise((resolve, reject) => {
      deleteStripeFromTemplate(stripeData, TempID)
        .then(response => {
          stripeData.component_id.forEach(id => {
            dispatch({
              type: "DELETE_DOCUMENT_COMPONENT",
              payload: id,
            });
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });

export const assignUserGroupToTemplateAction =
  (templateId, data, stateData) => dispatch =>
    new Promise((resolve, reject) => {
      assignUserGroupToTemplateService(templateId, data)
        .then(response => {
          dispatch({
            type: "UPDATE_TEMPLATE_USER_GROUP",
            payload: {
              templateId,
              stateData,
            },
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });

export const searchTemplates =
  (query, pageNum = 1) =>
  dispatch =>
    new Promise((resolve, reject) => {
      searchDocumentTemplates(query, pageNum)
        .then(response => {
          const {
            data: { Templates: templates } = {},
            headers: { has_more: hasMore } = {},
          } = response;
          dispatch({
            type:
              pageNum === 1
                ? "FETCH_DOCUMENT_TEMPLATES"
                : "LOAD_MORE_DOCUMENT_TEMPLATES",
            payload: {
              templates,
              hasMore: hasMore === "true",
              pageNum,
            },
          });
          resolve(response);
        })
        .catch(error => {
          console.error(
            `documentTemplateActions => searchTemplates => ${error}`,
          );
          reject(error);
        });
    });

export const assignRecipientTypeAction = (templateID, payload) => dispatch =>
  new Promise((resolve, reject) => {
    const reduxState = store.getState();
    const {
      template: { fields_used: fieldUsed },
    } = reduxState.TemplateStore;
    const updatedFormFields = [...fieldUsed];
    // updatedFormFields.forEach(item => {
    //   if (item.id === payload[0].field_id) {
    //     item.filler_type = payload[0].filler_type;
    //   }
    // });
    assignRecipientTypeService(templateID, payload)
      .then(response => {
        updatedFormFields.forEach(item => {
          response.Fields.forEach(field => {
            if (item.id === field.field_id) {
              item.filler_type = field.filler_type;
            }
          });
        });
        dispatch({
          type: "UPDATE_TEMPLATE_FILLER_TYPE",
          payload: {
            updatedFormFields,
          },
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const downloadTemplateCsvAction = (templateID, payload) => dispatch =>
  new Promise((resolve, reject) => {
    downloadTemplateCsvService(templateID, payload)
      .then(response => {
        dispatch({
          type: "DOWNLOAD_CSV_FILE",
          payload: {
            response,
          },
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
export const convertToTableField =
  ({ section, blockType, blockID }) =>
  dispatch => {
    dispatch({
      type: "CONVERT_TO_TABLE_FIELD",
      payload: {
        section,
        blockType,
        blockID,
      },
    });
  };

export const editTableFormField =
  (section, clauseOptions, blockID, blockType) => dispatch => {
    dispatch({
      type: "EDIT_TABLE_FORM_FIELD",
      payload: { section, clauseOptions, blockID, blockType },
    });
  };

export const nukeTableFormField = () => dispatch => {
  dispatch({
    type: "NUKE_TABLE_FORM_FIELD",
  });
};

export const updateTableFormFieldAndSection =
  (tableFormField, section) => dispatch => {
    const payload = {
      section,
      tableFormField,
    };
    dispatch({
      type: "UPDATE_TABLE_FORM_FIELD_AND_SECTION",
      payload,
    });
  };

export const downloadTemplateJsonDataAction = templateID => dispatch =>
  new Promise((resolve, reject) => {
    downloadTemplateJsonDataService(templateID)
      .then(response => {
        dispatch({
          type: "DOWNLOAD_JSON_FILE",
          payload: {
            response,
          },
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
export const toggleTabViewInTemplate =
  ({ tabView, tabName }) =>
  async dispatch => {
    dispatch({
      type: "TOGGLE_TEMPLATE_TAB_VIEW",
      payload: {
        tabView,
        tabName,
      },
    });
  };

export const hanldeCustomFieldPane =
  (isOpen, view, page, errHandling) => dispatch => {
    dispatch(updateToolPaneData(isOpen, view, page, errHandling));
    dispatch(toggleDynamicFieldView("CUSTOM"));
  };

export const fetchDocCustomFieldData = () => dispatch =>
  new Promise((resolve, reject) => {
    fetchDocCustomField()
      .then(res => {
        res = convertIntermediateJson(res);

        dispatch({
          type: "FETCH_CUSTOM_FIELD",
          payload: res,
        });
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const deleteFormFieldFromEditor = fieldDiffList => dispatch => {
  const reduxState = store.getState();
  const {
    template: { fields_used },
    fieldSectionMapping,
  } = reduxState.TemplateStore;
  const mappingList = fieldSectionMapping[fieldDiffList.deleted[0]];
  let updatedList = fields_used;
  if (Array.isArray(fields_used) && fields_used.length > 0) {
    if (Array.isArray(mappingList) && mappingList.length === 1) {
      updatedList = fields_used.filter(
        fields => fields.id !== fieldDiffList.deleted[0],
      );
    } else if (Object.keys(fieldSectionMapping).length === 0) {
      updatedList = fields_used.filter(
        fields => fields.id !== fieldDiffList.deleted[0],
      );
    }
    updatedList.forEach(fields => {
      if (fields.conditional_logic) {
        if (fields.conditional_logic.parent_id === fieldDiffList.deleted[0]) {
          fields.conditional_logic = {};
        }
      }
      return fields;
    });
    dispatch({
      type: "UPDATE_DELETED_FORM_FIELDS",
      payload: updatedList,
    });
  }
};

export const updateStatusFilters = filters => dispatch => {
  dispatch({
    type: "UPDATE_TEMPLATE_STATUS_FILTERS",
    payload: filters,
  });
};

export const addLogicToFieldsInTemplateAction = payload => dispatch =>
  new Promise((resolve, reject) => {
    const reduxState = store.getState();
    const {
      template: { fields_used: fieldUsed },
    } = reduxState.TemplateStore;
    addLogicToFieldsInTemplateService(payload)
      .then(res => {
        const updatedFormFields = [...fieldUsed];
        const updatedFields = updatedFormFields.find(
          item => item.id === res.LogicMapping.child_id,
        );
        updatedFields.conditional_logic = res.LogicMapping;
        if (res.LogicMapping.child_filler_type) {
          updatedFields.filler_type = res.LogicMapping.child_filler_type;
        }
        dispatch({
          type: "ADD_CONDITIONAL_LOGIC_TO_FIELD",
          payload: updatedFormFields,
        });
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const removeLogicForFieldAction = (templateID, fieldID) => dispatch =>
  new Promise((resolve, reject) => {
    const reduxState = store.getState();
    const {
      template: { fields_used: fieldUsed },
    } = reduxState.TemplateStore;
    removeLogicForFieldService(templateID, fieldID)
      .then(res => {
        const updatedFormFields = [...fieldUsed];
        const updatedFields = updatedFormFields.find(
          item => item.id === fieldID,
        );
        updatedFields.conditional_logic = {};
        dispatch({
          type: "REMOVE_CONDITIONAL_LOGIC_TO_FIELD",
          payload: updatedFormFields,
        });
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });
